import React from 'react';

const PrizeRevealModal = ({
  isOpen,
  prize,
  onClose,
  onViewLocker,
  onBackToHomepage = null,
  originOffset = null,
  demoMode = false,
  titleOverride = null,
  messageOverride = null,
  demoCtaLabel = null,
}) => {
  if (!isOpen || !prize) {
    return null;
  }

  const isTokenBonus = typeof prize?.tokenBonus === 'number' && prize.tokenBonus > 0;
  const prizeName = prize?.name || 'Mystery prize';
  const prizeEmoji = prize?.image;
  const prizeImage =
    typeof prize?.imageUrl === 'string' && prize.imageUrl.trim().length > 0
      ? prize.imageUrl.trim()
      : '/assets/ponpon-logo.svg';
  const prizeRarity = prize?.rarity ? prize.rarity.toString().toUpperCase() : null;
  const titleText = typeof titleOverride === 'string' && titleOverride.trim().length > 0
    ? titleOverride
    : 'Congratulations!';

  const modalStyle = originOffset
    ? {
        '--modal-origin-x': `${originOffset.x}px`,
        '--modal-origin-y': `${originOffset.y}px`,
      }
    : undefined;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-ponpon-navy/40 px-4 py-10 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="prize-reveal-title"
    >
      <div
        className="modal-appear relative w-full max-w-3xl overflow-hidden rounded-3xl border border-white/70 bg-white/95 p-6 shadow-[0_22px_55px_rgba(30,35,51,0.3)]"
        style={modalStyle}
      >
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-4 text-center">
            <div className="prize-reveal-image relative flex h-28 w-28 items-center justify-center rounded-2xl">
              {isTokenBonus ? (
                <img src="/assets/token-icon.png" alt={prizeName} className="max-h-24 w-auto object-contain" />
              ) : prizeEmoji ? (
                <span className="text-6xl">{prizeEmoji}</span>
              ) : (
                <img src={prizeImage} alt={prizeName} className="max-h-24 w-auto object-contain" />
              )}
            </div>
            <h2 id="prize-reveal-title" className="text-2xl font-semibold text-ponpon-navy">
              {titleText}
            </h2>
            {messageOverride === null ? (
              <p className="text-sm text-ponpon-navy/70">
                {isTokenBonus ? (
                  <>
                    <strong>{prizeName}</strong> have been added to your balance.
                  </>
                ) : (
                  <>
                    You've got "<strong>{prizeName}</strong>"! It's now stored safely in your Locker.
                  </>
                )}
              </p>
            ) : messageOverride ? (
              <p className="text-sm text-ponpon-navy/70">{messageOverride}</p>
            ) : null}
            {prizeRarity ? (
              <span className="inline-block rounded-full border border-ponpon-navy/15 bg-ponpon-navy/5 px-3 py-1 text-xs font-semibold text-ponpon-navy/70">
                {prizeRarity}
              </span>
            ) : null}
          </div>

          {demoMode ? (
            <div className="flex justify-center">
              <button
                type="button"
                onClick={onViewLocker}
                className="inline-flex items-center justify-center rounded-full bg-ponpon-coral px-6 py-2.5 text-sm font-semibold text-white shadow-[0_12px_26px_rgba(226,58,50,0.28)] transition hover:-translate-y-0.5 hover:bg-[#E23A32] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ponpon-coral/60"
              >
                {demoCtaLabel || 'View Locker'}
              </button>
            </div>
          ) : isTokenBonus ? (
            <div className="flex justify-center">
              <button
                type="button"
                onClick={onBackToHomepage ?? onClose}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-ponpon-coral px-6 py-2.5 text-sm font-semibold text-white shadow-[0_12px_26px_rgba(226,58,50,0.28)] transition hover:-translate-y-0.5 hover:bg-[#E23A32] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ponpon-coral/60"
              >
                <span aria-hidden="true">←</span> {onBackToHomepage ? 'Back to Homepage' : 'Back to machine'}
              </button>
            </div>
          ) : (
            <div className="grid gap-3 sm:grid-cols-2">
              <button
                type="button"
                onClick={onViewLocker}
                className="inline-flex items-center justify-center rounded-full border border-ponpon-navy/15 bg-white px-4 py-2.5 text-sm font-semibold text-ponpon-navy shadow-sm transition hover:-translate-y-0.5 hover:bg-ponpon-navy/5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ponpon-navy/40"
              >
                View Locker
              </button>
              <button
                type="button"
                onClick={onClose}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-ponpon-coral px-4 py-2.5 text-sm font-semibold text-white shadow-[0_12px_26px_rgba(226,58,50,0.28)] transition hover:-translate-y-0.5 hover:bg-[#E23A32] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ponpon-coral/60"
              >
                <span aria-hidden="true">←</span> Back to machine
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrizeRevealModal;

